module.exports = __webpack_public_path__ + "static/media/r.7fe39d61.png";